await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/asset-publisher-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2024 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {openSimpleInputModal} from 'frontend-js-web';

export default function propsTransformer({additionalProps, ...props}) {
	return {
		...props,
		onClick() {
			openSimpleInputModal({
				dialogTitle: Liferay.Language.get('collection-title'),
				formSubmitURL: additionalProps.url,
				mainFieldLabel: Liferay.Language.get('title'),
				mainFieldName: 'title',
				mainFieldPlaceholder: Liferay.Language.get('title'),
				namespace: additionalProps.portletNamespace,
			});
		},
	};
}
